export default __webpack_public_path__ + "locales/az/Errors.json?hash=bc24b0f437935f88bf4e462dc0f0b69e";